import React from 'react';
import ShippingCalendar from '../../components/calendar/ShippingCalendar';

/**
 * Month view component that shows the outbound calendar view for scheduling
 */
const MonthView = ({ 
  truckData, 
  setShowScheduleForm, 
  setPreSelectedDate, 
  refreshData, 
  isLoading
}) => {
  return (
    <div className="h-full overflow-hidden">
      <ShippingCalendar
        truckData={truckData}
        setShowScheduleForm={setShowScheduleForm}
        setPreSelectedDate={setPreSelectedDate}
        refreshData={refreshData}
        isLoading={isLoading}
        mode="outbound"
      />
    </div>
  );
};

export default MonthView;